exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ShareModal-module__content___2cycm{display:grid;gap:2.5rem}.ShareModal-module__content___2cycm .ShareModal-module__twoColumn___1JT_q{display:grid;gap:1rem}@media screen and (min-width:768px){.ShareModal-module__content___2cycm .ShareModal-module__twoColumn___1JT_q{gap:2rem;grid-template-columns:1fr auto}}.ShareModal-module__content___2cycm .ShareModal-module__bar___3hWAU{height:1px;width:100%;background-color:#ececec;margin-bottom:1.25rem}", ""]);

// exports
exports.locals = {
	"content": "ShareModal-module__content___2cycm",
	"twoColumn": "ShareModal-module__twoColumn___1JT_q",
	"bar": "ShareModal-module__bar___3hWAU"
};